<div class="grid">
  <div class="col-12">
    <div class="card">
      <div class="surface-section px-4 py-5 md:px-2 lg:px-4">
        <div id="head" class="grid mb-3">
          <div class="col-12 md:col-11">
            <span class="block text-3xl font-medium text-900 mb-2"
              >Registrar Compra
            </span>
          </div>
          <div class="col-12 md:col-1">
            <pg-cart-purchase></pg-cart-purchase>
          </div>
        </div>
        <p-steps
          [model]="items"
          [(activeIndex)]="activeIndex"
          [readonly]="true"
        >
        </p-steps>
      </div>

      <div *ngIf="activeIndex === 0" class="field col-12">
        <div class="flex align-items-center justify-content-center">
          <pg-purchase-provider-selection
            (stepsEmitter)="onReceiveAction($event)"
          ></pg-purchase-provider-selection>
        </div>
      </div>
      <div *ngIf="activeIndex === 1" class="field col-12">
        <div class="flex align-items-center justify-content-center">
          <pg-purchase-document-setting-selection
            class="w-9"
            (stepsEmitter)="onReceiveAction($event)"
          ></pg-purchase-document-setting-selection>
        </div>
      </div>
      <div *ngIf="activeIndex === 2" class="field col-12">
        <pg-purchase-product-to-warehouse-selection
          (stepsEmitter)="onReceiveAction($event)"
          (itemSelected)="onItemToSideBar($event)"
        >
        </pg-purchase-product-to-warehouse-selection>
      </div>

      <div *ngIf="activeIndex === 3" class="field col-12">
        <pg-purchase-confirmation-selection
          (stepsEmitter)="onReceiveAction($event)"
        >
        </pg-purchase-confirmation-selection>
      </div>
    </div>
  </div>
</div>

<div *ngIf="openSideBar">
  <pg-product-of-provider-sidebar
    type="new"
    [item]="itemToSideBar"
    (close)="onCloseSideBar($event)"
  ></pg-product-of-provider-sidebar>
</div>
